<template>
    <router-link :to="`/${currentLocale}`" @click="handleClick()" tag="div">
        <!-- <img src="../../../static/images/icons/aspn_icon/logo/logo.png" v-show="isMobile"  alt="Logo" class="main-logo"  />
    <img src="../../../static/images/icons/aspn_icon/logo/logo.png" v-show="!isMobile"  alt="Logo" class="main-logo"  /> -->

        <IconMode>
            <template #default="{ index }">
                <img
                    src="@static/images/icons/aspn_icon/logo/logo-light.png"
                    v-if="['lightWeb', 'lightWebapp'].includes(index)"
                    class="main-logo"
                    alt="Logo"
                />
                <img
                    src="@static/images/icons/aspn_icon/logo/logo-dark.png"
                    v-else-if="['darkWeb', 'darkWebapp'].includes(index)"
                    class="main-logo"
                    alt="Logo"
                />
            </template>
        </IconMode>
    </router-link>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import { sharedState } from "../../js/sharedState/index";
export default {
    computed: {
        ...mapGetters(["currentLocale", "isMobile"]),
    },
    methods: {
        handleClick() {
            sessionStorage.removeItem("calendarDate");
            sharedState.mainUpdate = true;
            sharedState.mainLogoClicked = true;
        },
    },
};
</script>

<style>
.main-logo {
    width: inherit;
    height: 63px;
}
@media(max-width: 768px) {
    /* for test */
    .main-logo {
        height: 40px;
    }
}
</style>
